import React, { Component } from "react";
import { Button, Card, CardContent, TextField } from "@material-ui/core";
import request from "superagent";
import { url_endpoint } from "../config";
import { BrowserRouter } from "react-router-dom";
import FullScreenVideo from "../componentes/FullScreenVideo";
import postCastLogo from "../images/logo-postcast.png";
import background from "../images/background.png";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import LoaderSpinner from "../componentes/LoaderSpinner";
import logoNossaVoz from "../images/logo-nossavoz.png";
import logoBlogPlay from "../images/logo_blogplay_login.png";
import logoBlogPlayColor from "../images/logo_blogplay_color.svg";

import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: '',
      senha: "",
      loading: false,
      showPassword: false,
    };
  }

  async logar() {
    try {
      this.setState({ loading: true });

      const res = await request
        .post(url_endpoint + "auth/login")
        .send({ login: this.state.login, senha: this.state.senha });
      const resData = JSON.parse(res.text)
      localStorage.setItem("token", resData.secret);
      if (resData.admin) {
        this.props.history.push("/admin");
      } else {
        this.props.history.push("/painel");
      }
      this.setState({ loading: false });

    } catch (err) {
      console.log(err);
      alert(
        "Problemas ao logar, verifique se informou o usuário e senha corretamente!"
      );
      this.setState({ loading: false });
    }
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  render() {
    let width = window.innerWidth
    window.onresize = () => {
      width = window.innerWidth
      this.setState({})
    }

    let isMobile = width < 700
    return (
      <div style={{ display: 'grid', gridTemplateAreas: isMobile ? "'form form'" : "'image form'", gridTemplateColumns: '1fr 1fr', height: '100%' }}>
        {!isMobile &&
          <img src={background} style={{ objectFit: 'cover', gridArea: 'image', width: '110%', height: '100%', overflow: 'hidden' }}></img>
        }
        <div style={{ backgroundColor: 'white', zIndex: '2', borderRadius: isMobile ? '0' : '50px 0px 0px 50px', boxShadow: '0px 4px 13px 0px grey', color: 'grey', position: 'relative', padding: '50px', gridArea: 'form', display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'center', width: '100%', rowGap: '30px' }}>
          <h1 style={{ alignSelf: 'center' }}>Fazer Login</h1>
          <FormControl>
            <TextField
              label={"Login"}
              variant="outlined"
              onChange={(evt) => this.setState({ login: evt.target.value })}
              value={this.state.login}
              className={"input"}
            />
          </FormControl>
          <FormControl>
            <TextField
              id="standard-adornment-password"
              className={"input"}
              label={"Senha"}
              variant="outlined"
              type={this.state.showPassword ? "text" : "password"}
              value={this.state.senha}
              onChange={(evt) => this.setState({ senha: evt.target.value })}
              InputProps={{
                endAdornment: (
                  < InputAdornment position="end" >
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={(evt) =>
                        this.setState({
                          showPassword: !this.state.showPassword,
                        })
                      }
                      onMouseDown={(evt) => this.handleMouseDownPassword}
                    >
                      {this.state.showPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </FormControl>

          <Button
            onClick={() => this.logar()}
            variant="contained"
            color={"primary"}
          >
            Fazer Login
          </Button>
          <img style={{ width: '25%', alignSelf: 'center', position: 'absolute', bottom: '5%' }} src={logoBlogPlayColor}></img>
        </div>
      </div >
    )
    return (
      <div className={"login_container"}>
        <img src={background} style={{ width: "100%" }}></img>

        <div className={"centralizarDiv"}>
          <img src={logoBlogPlay} alt="Logo" className={"logoLogin"} />

          <Card className={"login"}>
            <CardContent className={"login_content"}>
              <FormControl>
                <InputLabel htmlFor="standard-adornment-login">
                  Login
                </InputLabel>
                <Input
                  label={"Login"}
                  onChange={(evt) => this.setState({ login: evt.target.value })}
                  value={this.state.login}
                  className={"input"}
                />
              </FormControl>
              <FormControl>
                <InputLabel htmlFor="standard-adornment-password">
                  Senha
                </InputLabel>
                <Input
                  id="standard-adornment-password"
                  className={"input"}
                  label={"Senha"}
                  type={this.state.showPassword ? "text" : "password"}
                  value={this.state.senha}
                  onChange={(evt) => this.setState({ senha: evt.target.value })}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={(evt) =>
                          this.setState({
                            showPassword: !this.state.showPassword,
                          })
                        }
                        onMouseDown={(evt) => this.handleMouseDownPassword}
                      >
                        {this.state.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>

              <Button
                onClick={() => this.logar()}
                variant="contained"
                color={"primary"}
              >
                Login
              </Button>
            </CardContent>
          </Card>
        </div>

        {this.state.loading && <LoaderSpinner />}

        <div className={"login-logo-nossavoz"}>
          <img src={logoNossaVoz} width={100} />
        </div>
      </div>
    );
  }
}
export default Login;
